<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#FFF" d="M19 10H1c0 4.971 4.029 9 9 9s9-4.029 9-9z"/><path fill="red" d="M10 1a9 9 0 00-9 9h18a9 9 0 00-9-9z"/><g fill="none"><circle cx="10" cy="10" r="9"/><circle cx="10" cy="10" r="9.5" stroke="#E4E4E4"/></g></svg>
</template>

<script>
  export default {
    name: 'id-ID',
  };
</script>
